import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import PhoneInput from 'yoda-account-components/lib/components/PhoneInput/PhoneInput';
import Switch from 'yoda-core-components/lib/components/Switch/Switch';
import ClassNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { enableInputFieldMaskFix } from 'yoda-account-components/lib/common/Constants';
import * as styles from './Preferences.css';

const cx = ClassNames.bind(styles);

class MobileNotificationPreferences extends Component {
    static propTypes = {
        marketingText: PropTypes.objectOf(PropTypes.string).isRequired,
        orderText: PropTypes.objectOf(PropTypes.string).isRequired,
        notification: PropTypes.objectOf(PropTypes.string),
        emptyMarketInputError: PropTypes.bool.isRequired,
        emptyOrderInputError: PropTypes.bool.isRequired,
        marketErrorText: PropTypes.string.isRequired,
        orderSubscribeErrorText: PropTypes.string.isRequired,
        marketButtonClicked: PropTypes.func.isRequired,
        orderButtonClicked: PropTypes.func.isRequired,
        listenToInput: PropTypes.func.isRequired,
        messagesTexts: PropTypes.objectOf(PropTypes.object).isRequired,
        warningMessage: PropTypes.bool.isRequired,
        closeMessage: PropTypes.func.isRequired,
        submitNotification: PropTypes.func.isRequired,
        isMobileNotificationsActive: PropTypes.bool,
        setMobileNotificationsActive: PropTypes.func,
        enableMobileSubscriptionForMarketing: PropTypes.bool,
        enableMobileSubscriptionForOrderStatus: PropTypes.bool,
        clearInputError: PropTypes.bool,
        featureFlags: PropTypes.objectOf(PropTypes.object),
    };

    static defaultProps = {
        isMobileNotificationsActive: false,
        setMobileNotificationsActive: () => {},
        enableMobileSubscriptionForMarketing: false,
        enableMobileSubscriptionForOrderStatus: false,
        clearInputError: false,
        featureFlags: {},
        notification: {},
    };

    /* istanbul ignore next */
    static contextTypes = {
        deviceType: PropTypes.objectOf(PropTypes.any),
    };

    /* istanbul ignore next */
    onMarketingSubscriptionChange = (event) => {
        event.persist();
        this.props.marketButtonClicked(event?.target?.checked);
    };

    /* istanbul ignore next */
    onOrderStatusSubscriptionChange = (event) => {
        event.persist();
        this.props.orderButtonClicked(event?.target?.checked);
    };

    toggleMobileNotifications = () => {
        this.props.setMobileNotificationsActive(!this.props.isMobileNotificationsActive);
    };

    render() {
        const {
            marketingText,
            orderText,
            emptyMarketInputError,
            emptyOrderInputError,
            marketErrorText,
            orderSubscribeErrorText,
            submitNotification,
            listenToInput,
            messagesTexts,
            warningMessage,
            closeMessage,
            isMobileNotificationsActive,
            enableMobileSubscriptionForMarketing,
            enableMobileSubscriptionForOrderStatus,
            clearInputError,
            featureFlags,
            notification,
        } = this.props;
        const { deviceType: { isMobile } = {} } = this.context;
        const isSubscribedForOrderStatus =
            (orderText.status === null && orderText.number) || orderText.status;
        const orderSwitchLabel = isSubscribedForOrderStatus ? 'On' : 'Off';
        const isSubscribedForMarketingNotifications = marketingText.status;
        const marketingSwitchLabel = isSubscribedForMarketingNotifications ? 'On' : 'Off';
        const inputErrorMessage = messagesTexts?.mobileNotifications?.inputErrorMessage || '';
        return (
            <div className={cx('preferences')}>
                <div
                    className={cx(
                        'notifyAccordion',
                        isMobileNotificationsActive || !isMobile ? 'active' : 'inActive'
                    )}
                >
                    <div className={cx('notify')}>
                        <div
                            className={`${cx('notifyInnerContent', 'firstSection')} ${dt([
                                'pb-6',
                                'mb-6',
                                'border-b',
                                'border-solid',
                                'border-gray-15',
                                'text-black',
                            ])}`}
                        >
                            <h3
                                className={`${cx('marketingText')} ${dt([
                                    'text-large',
                                    'mb-4',
                                    'font-open-sans-semibold',
                                ])}`}
                            >
                                {get(messagesTexts, 'mobileNotifications.marketingTexts.title')}
                            </h3>
                            <div className={cx('notifyInnerEmailContent')}>
                                <div className={cx('subscribeContent')}>
                                    <p
                                        className={`${cx('saveExtraText')} ${dt([
                                            'text-normal',
                                            'mb-4',
                                        ])}`}
                                    >
                                        {get(
                                            messagesTexts,
                                            'mobileNotifications.marketingTexts.saveExtraText[0]'
                                        )}
                                        <em className={cx('textBold')}>
                                            {get(
                                                messagesTexts,
                                                'mobileNotifications.marketingTexts.saveExtraText[1]'
                                            )}
                                        </em>
                                        {get(
                                            messagesTexts,
                                            'mobileNotifications.marketingTexts.saveExtraText[2]'
                                        )}
                                    </p>
                                    {marketErrorText && (
                                        <div id="messageBox" className={dt(['mb-4'])}>
                                            <MessageBox
                                                type="error"
                                                level="section"
                                                title={marketErrorText}
                                                data-automation-id="at-accPO-InlineErrorMsg"
                                            />
                                        </div>
                                    )}
                                    <div className={`${cx('subscribeContent')} ${dt(['mb-4'])}`}>
                                        <Switch
                                            onClick={this.onMarketingSubscriptionChange}
                                            config={{
                                                checked: isSubscribedForMarketingNotifications,
                                                id: 'subscribeMobile',
                                                automationId: 'subscribeMobile',
                                                circleClassName: cx('subscribeSwitch'),
                                            }}
                                        >
                                            {`Subscription ${marketingSwitchLabel}`}
                                        </Switch>
                                    </div>
                                </div>
                                <div className={`${cx('phoneNo')} ${dt(['mb-4', 'pt-2'])}`}>
                                    <div
                                        className={`${cx('sm12', 'md12', 'noPadding')} ${dt([
                                            'lg:w-[327px]',
                                            '!p-0',
                                        ])}`}
                                    >
                                        <PhoneInput
                                            labelValue="Mobile Phone"
                                            name="marketingNumber"
                                            value={
                                                notification?.response?.communication?.phones[0]
                                                    ?.number || ''
                                            }
                                            isPhoneValidated={listenToInput}
                                            emptyInputError={emptyMarketInputError}
                                            convertLabelToAnimatingLegend
                                            // placeHolder="Mobile Number"
                                            phoneInputId="mktTextMsg"
                                            isFieldSet
                                            showLegend={false}
                                            isEmptyValid
                                            clearInputError={clearInputError}
                                            enableInputFieldMaskFix={enableInputFieldMaskFix}
                                            inputErrorMessage={inputErrorMessage}
                                            newIconForPersonalInfoAndPreferences
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`${cx('subscribeText')} ${dt([
                                        'mb-4',
                                        'text-xsmall',
                                        'text-gray-60',
                                    ])}`}
                                >
                                    {get(
                                        messagesTexts,
                                        'mobileNotifications.marketingTexts.firstCondition[0]'
                                    )}
                                    <em
                                        className={`${cx('textBold')} ${dt([
                                            'font-open-sans-bold',
                                        ])}`}
                                    >
                                        {get(messagesTexts, 'mobileNotifications.help')}
                                    </em>
                                    {get(
                                        messagesTexts,
                                        'mobileNotifications.marketingTexts.firstCondition[1]'
                                    )}
                                    <em
                                        className={`${cx('textBold')} ${dt([
                                            'font-open-sans-bold',
                                        ])}`}
                                    >
                                        {get(messagesTexts, 'mobileNotifications.stop')}
                                    </em>
                                    {get(
                                        messagesTexts,
                                        'mobileNotifications.marketingTexts.firstCondition[2]'
                                    )}
                                    <span className={dt(['block', 'mt-4'])}>
                                        <a
                                            className={dt(['underline'])}
                                            href={get(messagesTexts, 'TermsAndConditionsLink')}
                                        >
                                            {get(messagesTexts, 'viewTermsAndCondtions')}
                                        </a>
                                    </span>
                                    <span className={dt(['block', 'mt-4'])}>
                                        <a
                                            className={dt(['underline'])}
                                            href={get(messagesTexts, 'privacyPolicyLink')}
                                        >
                                            {get(messagesTexts, 'viewPrivacy')}
                                        </a>
                                    </span>
                                </div>
                                <div
                                    className={`${cx('subscribeText')} ${dt([
                                        'mb-4',
                                        'text-xsmall',
                                        'text-gray-60',
                                        'mb-4',
                                    ])}`}
                                >
                                    {get(
                                        messagesTexts,
                                        'mobileNotifications.marketingTexts.secondCondition[0]'
                                    )}
                                    <em
                                        className={`${cx('textBold')} ${dt([
                                            'font-open-sans-bold',
                                        ])}`}
                                    >
                                        {get(messagesTexts, 'mobileNotifications.help')}
                                    </em>
                                    {get(
                                        messagesTexts,
                                        'mobileNotifications.marketingTexts.secondCondition[1]'
                                    )}
                                    <em
                                        className={`${cx('textBold')} ${dt([
                                            'font-open-sans-bold',
                                        ])}`}
                                    >
                                        {get(messagesTexts, 'mobileNotifications.stop')}
                                    </em>
                                    {get(
                                        messagesTexts,
                                        'mobileNotifications.marketingTexts.secondCondition[2]'
                                    )}
                                </div>
                            </div>
                            <div className={`${cx('save')} ${dt(['flex', 'justify-end'])}`}>
                                <Button
                                    isDisabled={!enableMobileSubscriptionForMarketing}
                                    className={`${cx('button')} ${dt([
                                        'smOnly:!w-full',
                                        'md:!w-[154px]',
                                    ])}`}
                                    onClick={() => submitNotification('mobileSubscription')}
                                >
                                    {get(messagesTexts, 'saveButtonText')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    {get(featureFlags, 'enableOrderStatusTextAlerts', true) && (
                        <div className={cx('notify')}>
                            <div
                                className={`${cx('notifyInnerContent', 'firstSection')} ${dt([
                                    'mb-6',
                                    'text-black',
                                ])}`}
                            >
                                <h3
                                    className={`${cx('notifyHeading')} ${dt([
                                        'text-large',
                                        'mb-4',
                                        'font-open-sans-semibold',
                                    ])}`}
                                >
                                    {get(messagesTexts, 'mobileNotifications.orderTexts.title')}
                                </h3>
                                <div className={cx('notifyInnerEmailContent')}>
                                    {orderText.status === null &&
                                        orderText.number &&
                                        warningMessage && (
                                            <div id="messageBox" className={dt(['mb-4'])}>
                                                <MessageBox
                                                    showMessage={warningMessage}
                                                    type="information"
                                                    level="section"
                                                    title={get(
                                                        messagesTexts,
                                                        'mobileNotifications.orderTexts.confirmSMSText'
                                                    )}
                                                    data-automation-id="at-accPO-InlineInfoMsg"
                                                    hasClose
                                                    onClose={closeMessage}
                                                />
                                            </div>
                                        )}
                                    <div className={cx('subscribeContent')}>
                                        <p
                                            className={`${cx('saveExtraText')} ${dt([
                                                'text-normal',
                                                'mb-4',
                                            ])}`}
                                        >
                                            {get(
                                                messagesTexts,
                                                'mobileNotifications.orderTexts.description'
                                            )}
                                        </p>
                                        {orderSubscribeErrorText && (
                                            <div id="messageBox" className={dt(['mb-4'])}>
                                                <MessageBox
                                                    type="error"
                                                    level="section"
                                                    title={orderSubscribeErrorText}
                                                    data-automation-id="at-accPO-InlineErrorMsg"
                                                />
                                            </div>
                                        )}
                                        <div
                                            className={`${cx('subscribeContent')} ${dt(['mb-4'])}`}
                                        >
                                            <Switch
                                                onClick={this.onOrderStatusSubscriptionChange}
                                                config={{
                                                    checked: isSubscribedForOrderStatus,
                                                    id: 'subscribeOrder',
                                                    automationId: 'subscribeOrder',
                                                    circleClassName: cx('subscribeSwitch'),
                                                }}
                                            >
                                                {`Subscription ${orderSwitchLabel}`}
                                            </Switch>
                                        </div>
                                    </div>
                                    <div className={`${cx('phoneNo')} ${dt(['mb-4', 'pt-2'])}`}>
                                        <div
                                            className={`${cx('sm12', 'md12', 'noPadding')} ${dt([
                                                'lg:w-[327px]',
                                                '!p-0',
                                            ])}`}
                                        >
                                            <PhoneInput
                                                labelValue="Mobile Phone"
                                                name="orderNumber"
                                                value={
                                                    notification?.response?.communication?.phones[1]
                                                        ?.number || ''
                                                }
                                                isPhoneValidated={listenToInput}
                                                phoneInputId="orderMobileNumber"
                                                emptyInputError={emptyOrderInputError}
                                                convertLabelToAnimatingLegend
                                                // placeHolder="Mobile Number"
                                                isFieldSet
                                                showLegend={false}
                                                isEmptyValid
                                                clearInputError={clearInputError}
                                                enableInputFieldMaskFix={enableInputFieldMaskFix}
                                                inputErrorMessage={inputErrorMessage}
                                                newIconForPersonalInfoAndPreferences
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={`${cx('subscribeText')} ${dt([
                                            'mb-4',
                                            'text-xsmall',
                                            'text-gray-60',
                                        ])}`}
                                    >
                                        {get(
                                            messagesTexts,
                                            'mobileNotifications.orderTexts.condition'
                                        )}
                                        <span className={dt(['block', 'mt-4'])}>
                                            <a
                                                className={dt(['underline'])}
                                                href={get(messagesTexts, 'TermsAndConditionsLink')}
                                            >
                                                {get(messagesTexts, 'viewTermsAndCondtions')}
                                            </a>
                                        </span>
                                        <span className={dt(['block', 'my-4'])}>
                                            <a
                                                className={dt(['underline'])}
                                                href={get(messagesTexts, 'privacyPolicyLink')}
                                            >
                                                {get(messagesTexts, 'viewPrivacy')}
                                            </a>
                                        </span>
                                        {get(messagesTexts, 'helpText[0]')}
                                        <em
                                            className={`${cx('textBold')} ${dt([
                                                'font-open-sans-bold',
                                            ])}`}
                                        >
                                            {get(messagesTexts, 'mobileNotifications.help')}
                                        </em>
                                        {get(messagesTexts, 'helpText[1]')}
                                        <em
                                            className={`${cx('textBold')} ${dt([
                                                'font-open-sans-bold',
                                            ])}`}
                                        >
                                            {get(messagesTexts, 'mobileNotifications.stop')}
                                        </em>
                                        {get(messagesTexts, 'helpText[2]')}
                                    </div>
                                </div>
                                <div
                                    className={`${cx('save')} ${dt([
                                        'flex',
                                        'justify-end',
                                        'pb-4',
                                    ])}`}
                                >
                                    <Button
                                        isDisabled={!enableMobileSubscriptionForOrderStatus}
                                        className={`${cx('button')} ${dt([
                                            'smOnly:!w-full',
                                            'md:!w-[154px]',
                                        ])}`}
                                        onClick={() =>
                                            submitNotification('orderStatusSubscription')
                                        }
                                    >
                                        {get(messagesTexts, 'saveButtonText')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default MobileNotificationPreferences;
